import { FC } from 'react';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { useSubscription } from '@meraki-internal/state';
import { IAllergy, IPatient } from '../caremap/ICareMap';
import { CareMapState } from '../caremap/CareMapState';
import { MixPanelEventEmitter } from '../metrics/MixPanelEventEmitter';
import { AllergyDescriptor } from './AllergyDescriptor';
import { StructuredRecordList } from './structured-records/StructuredRecordList';

export type IAllergyList = {
    patient: IPatient;
    canAddEdit: boolean;
    allergies?: IAllergy[];
    onAdd: () => void;
    onClick: (id: string) => void;
};

export const AllergyList: FC<IAllergyList> = ({ patient, canAddEdit, allergies, onClick, onAdd }) => {
    const descriptor = useInstance(AllergyDescriptor);
    const mixpanel = useInstance(MixPanelEventEmitter);

    const careMapState = useInstance(CareMapState);
    useSubscription(() => careMapState);

    return (
        <StructuredRecordList
            descriptor={descriptor}
            records={allergies || []}
            canAddEdit={canAddEdit}
            isPublic={patient.allergiesIsPublic ?? false}
            onTogglePublic={() => {
                const willBePublic = !patient.allergiesIsPublic;
                mixpanel.track('Allergy Privacy Toggled', () => ({
                    'State': willBePublic ? 'public' : 'private'
                }));
                careMapState.updatePatient({ ...patient, allergiesIsPublic: willBePublic });
            }}
            onRowClick={onClick}
            onAdd={onAdd}
        />
    );
};
